import { render } from "./Register.vue?vue&type=template&id=6e55887a"
import script from "./Register.vue?vue&type=script&lang=ts"
export * from "./Register.vue?vue&type=script&lang=ts"
script.render = render

export default script